module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<h4>1-click apply to similar jobs!</h4>\n<div class="job-card-list-container"><div class="job-card-list"></div></div>\n<div class="job-card-list-load-more-container">\n    <a class="btn btn-large btn-primary job-card-list-load-more hidden" href="#">Load More</a>\n</div>\n';

}
return __p
}